import { LazyExoticComponent, FC, lazy } from "react";
import PrivateLayout from "layouts/private";
import InfoLayout from "layouts/info";
import retry from "routes/retry";

export type AppRoute = {
  path: string;
  component: LazyExoticComponent<FC<any>>;
  layout: FC<any> | null;
  title?: string;
  exact?: boolean;
  isPrivate?: boolean;
};

const routes: Array<AppRoute> = [
  {
    path: '/',
    component: lazy(() => retry(() => import("./pages/index"))),
    layout: null,
    title: '',
    exact: true
  },
  {
    path: "/invalid-token",
    component: lazy(() => retry(() => import("./pages/invalid-token"))),
    layout: InfoLayout,
    title: "Invalid Token",
    exact: true,
  },
  {
    path: "/auth/:code",
    component: lazy(() => retry(() => import("./pages/auth"))),
    layout: null,
    title: "Authorization",
    exact: true,
  },
  {
    path: '/job/expired',
    component: lazy(() => retry(() => import("./pages/job/expired"))),
    layout: InfoLayout,
    title: 'Job is Expired',
    exact: true
  },
  {
    path: '/job/configuration',
    component: lazy(() => retry(() => import("./pages/job/configuration"))),
    layout: PrivateLayout,
    title: 'Job Configuration',
    exact: true
  },
  {
    path: '/job/review/:code',
    component: lazy(() => retry(() => import("./pages/job/review"))),
    layout: PrivateLayout,
    title: 'Job Accept or Decline',
    exact: true
  }
];

export default routes;